import { PopUpManagerV2Slice } from "./types";

export const initialState: PopUpManagerV2Slice = {
	stack: [],
	maxStackSize: null
};
